export const EL = {
  "Open document": "ÎÎ½Î¿Î¹Î³Î¼Î± ÎµÎ³Î³ÏÎ¬ÏÎ¿Ï",
  "Upload file": "ÎÎ½Î­Î²Î±ÏÎ¼Î± Î±ÏÏÎµÎ¯Î¿Ï",
  "Drop file here to upload": "ÎÏÎ®ÏÏÎµ ÏÎ¿ Î±ÏÏÎµÎ¯Î¿ ÎµÎ´Ï Î³Î¹Î± Î¼ÎµÏÎ±ÏÏÏÏÏÏÎ·",
  "Disc": "ÎÎ¯ÏÎºÎ¿Ï",
  "URL": "URL",
  "FILE": "ÎÎ¡Î§ÎÎÎ",
  "SIZE": "ÎÎÎÎÎÎÎ£",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Î¦Î¿ÏÏÏÎ½ÎµÎ¹ ÏÎ±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ.",
  "Fit Width": "Fit Width",
  "Fit Height": "Fit Height",
  "Password protected document": "ÎÎ³Î³ÏÎ±ÏÎ¿ ÏÏÎ¿ÏÏÎ±ÏÎµÏÎ¼Î­Î½Î¿ Î¼Îµ ÎºÏÎ´Î¹ÎºÏ ÏÏÏÏÎ²Î±ÏÎ·Ï",
  "Password": "ÎÏÎ´Î¹ÎºÏÏ ÏÏÏÏÎ²Î±ÏÎ·Ï",
  "Open": "ÎÎ½Î¿Î¹Î¾Îµ",
  "Password Required": "ÎÏÎ±Î¹ÏÎµÎ¯ÏÎ±Î¹ ÎºÏÎ´Î¹ÎºÏÏ ÏÏÏÏÎ²Î±ÏÎ·Ï",
  "Incorrect password": "ÎÎ¬Î¸Î¿Ï ÎºÏÎ´Î¹ÎºÏÏ",
  "Error": "ÎÎ¬Î¸Î¿Ï",
  "Something went wrong": "ÎÎ¬ÏÎ¹ ÏÎ®Î³Îµ ÏÏÏÎ±Î²Î¬",
  "Server is not available": "Î Î´Î¹Î±ÎºÎ¿Î¼Î¹ÏÏÎ®Ï Î´ÎµÎ½ ÎµÎ¯Î½Î±Î¹ Î´Î¹Î±Î¸Î­ÏÎ¹Î¼Î¿Ï",
  "of": "ÏÎ¿Ï",
  "Please wait...": "Î Î±ÏÎ±ÎºÎ±Î»Ï ÏÎµÏÎ¹Î¼Î­Î½ÎµÏÎµ..."
};
